import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { Box } from '../Box';
import { Text } from '../Text';
import { Column } from '../Layout';
import Image from '../Image';

export const PerformanceHeroLayout = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;

  ${mediaQueries.tablet} {
    flex-direction: row-reverse;
    padding-left: ${({ theme }) => theme.spacing.l};
    padding-right: ${({ theme }) => theme.spacing.l};
    margin-top: ${({ theme }) => theme.spacing.s};
    justify-content: center;
  }

  ${mediaQueries.desktop} {
    padding-left: ${({ theme }) => theme.spacing.xl};
    padding-right: ${({ theme }) => theme.spacing.xl};
  }
`;

export const ImageBox = styled(Box)`
  position: relative;

  ${mediaQueries.tablet} {
    flex: 1;
    padding-left: ${({ theme }) => theme.spacing.m};
  }
`;

export const TextContainer = styled(Column)`
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing.sm};
  padding-right: ${({ theme }) => theme.spacing.sm};

  ${mediaQueries.tablet} {
    align-items: flex-start;
  }
`;

export const PerformanceHeroImage = styled(Image)`
  height: 100%;
  width: 100%;

  ${mediaQueries.tablet} {
    max-width: ${pxToRem(630)};
    max-height: ${pxToRem(630)};
    border-radius: ${({ theme }) => theme.borderRadius.milestoneShape};
  }
`;

export const MobileCtaContainer = styled('div')`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopCtaContainer = styled('div')`
  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const HeaderText = styled(Text)`
  text-align: center;
  font-weight: ${({ theme }) => theme.fontWeight.h2};
  margin-top: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.s};

  ${mediaQueries.tablet} {
    text-align: left;
    font-weight: ${({ theme }) => theme.fontWeight.h1};
    margin-bottom: ${({ theme }) => theme.spacing.m};
    margin-top: 0;
  }
`;

export const SubheadText = styled(Text)<{
  subheadingSize?: string | null;
  mobileSubheadingSize?: string | null;
}>`
  font-size: ${({ mobileSubheadingSize }) =>
    mobileSubheadingSize ? `${mobileSubheadingSize}rem` : '1.125rem'};
  line-height: 1.625rem;
  margin: 0 auto;
  margin-bottom: ${({ theme }) => theme.spacing.ml};
  text-align: center;

  ${mediaQueries.tablet} {
    font-size: ${({ subheadingSize }) =>
      subheadingSize ? `${subheadingSize}rem` : '1.75rem'};
    text-align: left;
    margin-top: 0;
    line-height: 1.125;
  }
`;

export const SpacerColumn = styled(Column)`
  ${mediaQueries.tablet} {
    display: none;
  }

  ${mediaQueries.desktop} {
    display: flex;
  }
`;
